import { useTranslation } from "react-i18next"
import { UserCircle } from "@phosphor-icons/react"
import { TooltipContent, TooltipCustom, TooltipPortal, TooltipTrigger } from "@/components/ui/tooltip"
import { CALLER_ROLE_ITEMS } from "@/modules/patients/constants/Patient"
import { CallerRole } from "@/types/__generated__/union-types"

interface CallerRoleIconProps {
  callerRole: CallerRole | null | undefined
}

export const CallerRoleIcon = ({ callerRole }: CallerRoleIconProps) => {
  const { t } = useTranslation()

  if (callerRole === null || callerRole === undefined || callerRole === "PATIENT") {
    return null
  }

  const label = CALLER_ROLE_ITEMS.find((item) => item.value === callerRole)?.label

  return (
    <>
      <span>{" • "}</span>
      <TooltipCustom>
        <TooltipTrigger asChild>
          <UserCircle className="text-on-surface-subdued size-4" data-testid="caller-role-icon" />
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent side="bottom" align="center">
            {t("common.callerRole")}: {label}
          </TooltipContent>
        </TooltipPortal>
      </TooltipCustom>
    </>
  )
}
